<bb-page-header 
	[icon]="'cloud-upload'" 
	[title]="'VAST_SERVICE' | translate" 
	[allowCustomPreset]="true"
	[filterConfig]="filterConfig"
	[currentPath]="listConfiguration.activePath">
</bb-page-header>

<div class="body-column">
	<div class="creative-upload-container">
		<bb-upload [createNewMediaclip]="true" [mediaclipDefaults]="{ status: 'published', usetype: 'commercial', subusetype: ['vast_creative'] }" (mediaclipCreated)="onCreativeCreated()" [multi]="false"></bb-upload>

		<div *ngIf="!disableImport" class="import-container">
			<bb-import [autoPublish]="true" [usetype]="'commercial'" [subusetype]="['vast_creative']" (importJobClipCreated)="onCreativeCreated()"></bb-import>
		</div>
	</div>

	<bb-table-container>

		<bb-table-header>
			<bb-table-header-cell class="thumb"></bb-table-header-cell>
			<bb-table-header-cell class="icon"></bb-table-header-cell>
			<bb-table-header-cell property="id">{{ 'ID' | translate }}</bb-table-header-cell>
			<bb-table-header-cell property="title">{{ 'TITLE' | translate }}</bb-table-header-cell>
			<bb-table-header-cell property="length">{{ 'LENGTH' | translate }}</bb-table-header-cell>
			<bb-table-header-cell property="views">{{ 'VIEWS' | translate }}</bb-table-header-cell>
			<bb-table-header-cell property="createddate" class="date">{{ 'CREATED' | translate }}</bb-table-header-cell>
			<bb-table-header-cell optional property="createdBy">{{ 'CREATED_BY' | translate }}</bb-table-header-cell>
			<bb-table-header-cell property="updateddate" class="date">{{ 'UPDATED' | translate }}</bb-table-header-cell>
			<bb-table-header-cell optional property="updatedBy">{{ 'UPDATED_BY' | translate }}</bb-table-header-cell>
			<bb-table-header-cell class="buttons"></bb-table-header-cell>
		</bb-table-header>

		<bb-table-row *ngFor="let row of rows" [row]="row">
			<bb-table-cell class="thumb">
				<div class="thumbnail-wrapper" [attr.title]="row?.transcodingAverage < 1? ('TRANSCODING_STATUS' | translate) + (row?.transcodingAverage > 0 ? (row?.transcodingAverage | percentage: 0) : 'queued') : ''">
					<span *ngIf="row?.transcodingAverage < 1" class="transcoding-progress">{{ row?.transcodingAverage | percentage: 0 }}</span>
					<div *ngIf="row?.transcodingAverage < 1" class="thumbnail-overlay"></div>

					<span [innerHTML]="row.data | thumbnail : 50:28:null:row?.transcodingAverage < 1 | async"></span>
				</div>
			</bb-table-cell>
			<bb-table-cell><span style="white-space: no-break;"><span [innerHTML]="row.data | clipIcon"></span></span></bb-table-cell>
			<bb-table-cell property="id">{{ row.data.id }}</bb-table-cell>
			<bb-table-cell property="title" class="overflow">
				<span [hidden]="!row.data.title">{{ row.data.title }}</span>
				<span [hidden]="row.data.title" class="filename">{{ row.data.originalfilename }}</span>
				
			</bb-table-cell>
			<bb-table-cell property="length">{{ row.data.length | seconds }}</bb-table-cell>
			<bb-table-cell property="views">{{ row.data.views }}</bb-table-cell>
			<bb-table-cell property="status" *ngIf="row?.data?.sourceid?.startsWith('live_api_')"><span [innerHTML]="(row.data | statusIcon) + (row.data | bbStreamStatusIcon | async)" class="stream-status-icon"></span></bb-table-cell>
			<bb-table-cell property="status" *ngIf="!row?.data?.sourceid?.startsWith('live_api_')"><span [innerHTML]="row.data | statusIcon"></span></bb-table-cell>
			<bb-table-cell property="createddate" class="date" [titleValue]="row.data.createddate | bbDate">{{ row.data.createddate | bbDate:'relative' }}</bb-table-cell>
			<bb-table-cell optional property="createdBy" [titleValue]="row.data.createdBy">{{ row.data.createdBy }}</bb-table-cell>
			<bb-table-cell property="updateddate" class="date" [titleValue]="row.data.updateddate | bbDate">{{ row.data.updateddate | bbDate:'relative' }}</bb-table-cell>
			<bb-table-cell optional property="updatedBy" [titleValue]="row.data.updatedBy">{{ row.data.updatedBy }}</bb-table-cell>
			<bb-table-cell class="buttons">

				<a class="button" [routerLink]="['/adservices/vastservice/creatives/', row.data.id, 'metadata']">
					<i class="fa fa-edit"></i>
				</a><!--

				--><a class="button" (click)="showPreview(row.data)">
					<i class="fa fa-code"></i>
				</a><!--

				--><a class="button"
				[hasPermission]="'interactivity'"
				[class.disabled]="!row.data.timelines || !row.data.timelines[0]"
				[routerLink]="['/library/interactivity/', row.data.timelines && row.data.timelines[0]]">
					<i class="fa fa-object-group"></i>
				</a><!--

				--><a class="button" [routerLink]="['/analytics/statistics/', row.data.id]">
					<i class="fa fa-line-chart"></i>
				</a><!--

				--><a class="button" (click)="deleteSingle(row.data)">
					<i class="fa fa-trash"></i>
				</a>

			</bb-table-cell>
		</bb-table-row>

	</bb-table-container>

	<div class="no-results" *ngIf="rows && !rows.length">{{ 'NO_MEDIA_CLIPS_FOUND' | translate }}</div>

	<bb-table-pager></bb-table-pager>

</div>

<ng-template #previewTemplate>
	<bb-vast-creative-preview [inModal]="true" [mediaclip]="previewClip"></bb-vast-creative-preview>
</ng-template>
